import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

export interface CENArticlesTemplateRowStyles {
    articlesWrapper: InjectableCss;
}

export const CENarticlesTemplateRowStyles: CENArticlesTemplateRowStyles = {
    articlesWrapper: {
        css: css`
            margin: 0 auto;
            max-width: 800px;
        `,
    },
};

const styles = CENarticlesTemplateRowStyles;

export const CENArticlesTemplateRow: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.articlesWrapper}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    );
};

const CENarticlesTemplateRow: WidgetModule = {
    component: CENArticlesTemplateRow,
    definition: {
        group: "Basic",
        icon: "image-landscape",
    },
};

export default CENarticlesTemplateRow;
